import Header from "organisms/Header";
import React, { useEffect, useState } from "react";

import Sidebar from "organisms/Sidebar";
import SuperAdminSidebar from "organisms/SuperAdminSidebar";
import { getCompanyId, removeAuth } from "services/identity.service";
import { useRouter } from "next/router";
import WarningModal from "organisms/WarningModal";
import Head from "next/head";
import CompanyHeader from "organisms/CompanyHeader";
import { magicLinkLoginNotificationChannel } from "constants";
import { userLogout } from "services/user.service";
import { Provider } from "react-redux";
import {store} from "../../redux/store";
import ToastAlert from "components/toast-message/components/ToastAlert";
// import { PersistGate } from 'redux-persist/integration/react'
import ErrorBoundary from "molecules/ErrorBoundaries/ErrorBoundary";
import FreshworksChatWidget from "components/FreshworksWidgetComponent";
import { getPlatformUserRole } from "lib/utils";

// persistance commented for temporary performance issue it will be added later

const Layout = (props) => {
  const router = useRouter();
  const companyId = getCompanyId();
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const userDetails = props.children.props.currentUserDetails;
  const handleLogOut = async () => {
    const res = await userLogout(userDetails);
    if (res.status) {
      removeAuth();
      router.push("/admin/login");
    }
  };
  const platformUserRole = router.pathname.startsWith("/superadmin")
    ? getPlatformUserRole(userDetails?.roles)
    : null;
  const platformUserTitle = platformUserRole
    ? `ANSR 1Connect - ${platformUserRole}`
    : "ANSR 1Connect - Admin";

  const showOnlyHeader = !!userDetails?.showOnlyHeader;

  useEffect(() => {

    const channel = new BroadcastChannel(magicLinkLoginNotificationChannel);

    const handleRefreshMessage = (event) => {
      // when some tab get magic link this event will trigger 
      const { details: { company } , type } = event.data;
      if (type === "redirect") {

        if(company){
          // redirect the page
          router.push(`/${company}/admin/dashboard/` , undefined, { shallow: true }).then(() => {
            window.location.reload();
          })
        }else{
          router.push(`/admin/login`)
        }
      
      }
    };

    channel.addEventListener("message", handleRefreshMessage);

    // Clean up the event listener when the component is unmounted
    return () => {
      channel.removeEventListener("message", handleRefreshMessage);
      channel.close();
    };
  }, []);

  return (
    <React.Fragment>
      <div className="flex bg-gray-50 overflow-hidden">
        <Head>
          <link rel="icon" href="/images/favicon.ico" />
          <title>
            {platformUserTitle}
          </title>
        </Head>
        <ToastAlert />
        <Provider store={store}>
          {/* <PersistGate loading={null} persistor={persistor}> */}
          <ErrorBoundary >
            {platformUserRole ? (
              <SuperAdminSidebar userDetails={userDetails} />
            ) : (
              userDetails &&
              !showOnlyHeader && <Sidebar userDetails={userDetails} />
            )}
            </ErrorBoundary>
            <div className={`w-full ${!userDetails?.showOnlyHeader && "pl-64"}`}>
              <ErrorBoundary >
              <CompanyHeader
                userDetails={userDetails}
                isLogoAvail={showOnlyHeader}
                onLogOut={() => setOpenWarningModal(true)}
              />
              </ErrorBoundary >
              <div className="min-h-screen w-full overflow-y-auto pt-28 pr-8 pb-15 pl-6">
              <ErrorBoundary >
                {props.children}
                </ErrorBoundary>
                <WarningModal
                  modalWidth="max-w-xl"
                  modalInnerWidth="w-full"
                  modalInnerAlignment="text-left"
                  modalHeading="Are you sure you want to sign out?"
                  modalButtonAlign="justify-end mt-6"
                  primaryBtnText="Yes"
                  outlineBtnText="No"
                  showModal={openWarningModal}
                  closeModalPopup={() => setOpenWarningModal(false)}
                  onClick={handleLogOut}
                />
              </div>
            </div>
          {/* </PersistGate> */}
        </Provider>
      </div>
      {userDetails?.name &&
        userDetails?.emailId &&
        !userDetails?.hideSupportWidgets && (
          <FreshworksChatWidget
            fullName={userDetails?.name}
            email={userDetails?.emailId}
          />
        )}
    </React.Fragment>
  );
};

export default Layout;
